<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-8">
        <div v-if="testimony" class="box">
          <div class="box-header with-border">
            <h3 class="box-title">Original Testimony : {{testimony.purpose ? testimony.purpose : '-'}}</h3>
            <i data-toggle="tooltip" data-placement="bottom" title="Delete" class="fa fa-trash clickable pull-right" v-on:click="confirm"></i>
          </div>
<!--
          <h4 v-if="testimony.purpose" class="subtitle">Purpose : {{testimony.purpose ? testimony.purpose : '-'}}</h4>
-->
          <!-- /.box-header -->
          <div class="box-body">

            <h4 v-if="testimony.victimIdentity" class="subtitle">Victim Identity</h4>

            <div class="row center-block victimIdentity">

              <div class="col-md-offset-1 col-md-5">

                <form v-if="testimony.victimIdentity" class="form-horizontal">
                  <!-- <div class="form-group">
                    <label class="col-sm-5 control-label">Firstname</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.victimIdentity.firstName ? testimony.victimIdentity.firstName : '-'}}</p>
                    </div>
                  </div> -->
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Name</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.victimIdentity.name ? testimony.victimIdentity.name : '-'}}</p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Gender</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.victimIdentity.gender ? testimony.victimIdentity.gender : '-'}}</p>
                    </div>
                  </div>
                  <div class="form-group" v-if="testimony.purpose === 'VICTIM'">
                    <label class="col-sm-5 control-label">Current location</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="testimony.victimLocation && testimony.victimLocation.otherPlace">{{testimony.victimLocation.otherPlace}}</span>
                        <span v-else-if="testimony.victimLocation && testimony.victimLocation.place">{{testimony.victimLocation.place}}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>

                  <div class="form-group" v-if="testimony.victimLocation && testimony.victimLocation.countryName">
                    <label class="col-sm-5 control-label">Country name</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span>{{testimony.victimLocation.countryName}}</span>
                        
                      </p>
                    </div>
                  </div>
                  <div class="form-group" v-if="testimony.purpose === 'VICTIM'">
                    <label class="col-sm-5 control-label">Surrounding</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="testimony.victimSurrounding && testimony.victimSurrounding.people">{{testimony.victimSurrounding.people.join(', ')}}</span>
                        <span v-else-if="testimony.victimSurrounding && testimony.victimSurrounding.otherPeople">{{testimony.victimSurrounding.otherPeople}}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>

                  <div class="form-group" v-if="testimony.distressLevel">
                    <label class="col-sm-5 control-label">Distress level</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        
                        <span v-if="testimony.distressLevel && testimony.distressLevel.levels">{{testimony.distressLevel.levels.join(', ')}}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>
                  <div class="form-group" v-if="testimony.distressLevel && testimony.distressLevel.levels && testimony.distressLevel.levels.includes('ALREADY_ASSISTED')">
                    <label class="col-sm-5 control-label">Assistance description</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="!testimony.distressLevel.alreadyAssistedDescription">-</span>
                        <span v-else>{{testimony.distressLevel.alreadyAssistedDescription}}</span>
                      </p>
                    </div>
                  </div>
                  <div class="form-group" v-if="testimony.distressLevel">
                    <label class="col-sm-5 control-label">Psychological state description</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="testimony.distressLevel.psychologicalStateDescription">{{testimony.distressLevel.psychologicalStateDescription}}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>
                </form>

              </div>

              <div class="col-md-5">
                <form v-if="testimony.victimIdentity" class="form-horizontal">
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Minor ?</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.victimIdentity.minor ? 'Yes': testimony.victimIdentity.minor === false ? 'No' : '-'}}</p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Age</label>
                    <div class="col-sm-7">
                      <p class="form-control-static" v-if="testimony.victimIdentity.birthdate">{{testimony.victimIdentity.birthdate | age}}</p>
                      <p class="form-control-static" v-if="!testimony.victimIdentity.birthdate">-</p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Birth date</label>
                    <div class="col-sm-7">
                      <p class="form-control-static" v-if="testimony.victimIdentity.birthdate">{{new Date(testimony.victimIdentity.birthdate)}}</p>
                      <p class="form-control-static" v-if="!testimony.victimIdentity.birthdate">-</p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Nationality</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.victimIdentity.nationality ? testimony.victimIdentity.nationality : '-'}}</p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-5 control-label">Ethnic group</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.victimIdentity.ethnicGroup ? testimony.victimIdentity.ethnicGroup : '-'}}</p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-5 control-label">Religion</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.victimIdentity.religion ? testimony.victimIdentity.religion : '-'}}</p>
                    </div>
                  </div>
                </form>
              </div>

            </div>

            <h4 class="subtitle">Contact</h4>
            <div class="row center-block details">
              <div class="col-md-6">
                <form v-if="testimony.victimIdentity" class="form-horizontal">
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Phone number</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="testimony.victimIdentity.phoneNumber">{{ testimony.victimIdentity.phoneNumber }}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-5 control-label">Email</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="testimony.victimIdentity.email">{{ testimony.victimIdentity.email }}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>

                  <div class="form-group" v-if="testimony.victimIdentity.organization">
                    <label class="col-sm-5 control-label">Organization</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span>{{ testimony.victimIdentity.organization }}</span>
                      </p>
                    </div>
                  </div>

                  <div class="form-group" v-if="testimony.victimIdentity.publicService">
                    <label class="col-sm-5 control-label">Public service</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span>{{ testimony.victimIdentity.publicService }}</span>
                      </p>
                    </div>
                  </div>
                </form>
              </div>

              <div class="col-md-5">
                <form v-if="testimony.victimIdentity" class="form-horizontal">
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Details</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="testimony.victimIdentity.contactDescription">{{testimony.victimIdentity.contactDescription}}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>
                </form>
              </div>

            </div>



            <hr v-if="testimony.witnessIdentity"/>

            <h4 v-if="testimony.witnessIdentity" class="subtitle">Witness</h4>

            <div class="row center-block details">

              <div class="col-md-offset-1 col-md-5">
                <form v-if="testimony.witnessIdentity" class="form-horizontal">
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Name</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.witnessIdentity.name ? testimony.witnessIdentity.name :
                        '-'}}</p>
                    </div>
                  </div>

                   <div class="form-group" v-if="testimony.purpose === 'THIRDPARTY_WITNESS'">
                    <label class="col-sm-5 control-label">Role</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.witnessIdentity.role ? testimony.witnessIdentity.role : '-'}}</p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-5 control-label">Status / profession</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.witnessIdentity.status ? testimony.witnessIdentity.status : '-'}}</p>
                    </div>
                  </div>
                  
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Phone number</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="testimony.witnessIdentity.phoneNumber">{{ testimony.witnessIdentity.phoneNumber }}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-5 control-label">Email</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="testimony.witnessIdentity.email">{{ testimony.witnessIdentity.email }}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>
                  <div class="form-group" v-if="testimony.witnessIdentity.organization">
                    <label class="col-sm-5 control-label">Organization</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span>{{ testimony.witnessIdentity.organization }}</span>
                      </p>
                    </div>
                  </div>

                  <div class="form-group" v-if="testimony.witnessIdentity.publicService">
                    <label class="col-sm-5 control-label">Public service</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span>{{ testimony.witnessIdentity.publicService }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Details</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="testimony.witnessIdentity.contactDescription">{{testimony.witnessIdentity.contactDescription}}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>
                </form>
              </div>

              <div class="col-md-5">
                <form v-if="testimony.witnessIdentity" class="form-horizontal">
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Nationality</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.witnessIdentity.nationality ? testimony.witnessIdentity.nationality : '-'}}</p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-5 control-label">Ethnic group</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.witnessIdentity.ethnicGroup ? testimony.witnessIdentity.ethnicGroup : '-'}}</p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-5 control-label">Religion</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.witnessIdentity.religion ? testimony.witnessIdentity.religion : '-'}}</p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-5 control-label">Close to victim?</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{
                        typeof testimony.witnessIdentity.victimLocationProximity === 'undefined' ?
                          '-' : 
                          testimony.witnessIdentity.victimLocationProximity ? 'Yes' : 'No'
                      }}</p>
                    </div>
                  </div>
                </form>
              </div>

            </div>

            <hr v-if="testimony.actionDetail"/>

            <h4 v-if="testimony.actionDetail" class="subtitle">Attack Details</h4>

            <div class="row center-block details">

              <div class="col-md-offset-1 col-md-5">
                <form v-if="testimony.actionDetail" class="form-horizontal">
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Attack types</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.actionDetail.attackTypes ? testimony.actionDetail.attackTypes.join(', ') : '-'}}</p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Attack description</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.actionDetail.attackDescription ? testimony.actionDetail.attackDescription : '-'}}</p>
                    </div>
                  </div>
                  <div class="form-group" v-if="testimony.actionPeriodicity">
                    <label class="col-sm-5 control-label">Attack periodicity</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="testimony.actionPeriodicity.periodicity">{{testimony.actionPeriodicity.periodicity.join(', ')}}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>
                  <div class="form-group" v-if="testimony.actionPeriodicity">
                    <label class="col-sm-5 control-label">Attack periodicity details</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="testimony.actionPeriodicity.description">{{testimony.actionPeriodicity.description}}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>

                  <hr />

                  <div class="form-group">
                    <label class="col-sm-5 control-label">Country</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="testimony.actionDetail.actionLocation.country">{{testimony.actionDetail.actionLocation.country}}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Town</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="testimony.actionDetail.actionLocation.town">{{testimony.actionDetail.actionLocation.town}}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>
                  <div class="form-group" v-if="testimony.actionDetail.actionLocation.prison">
                    <label class="col-sm-5 control-label">Prison</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span>{{testimony.actionDetail.actionLocation.prison}}</span>
                      </p>
                    </div>
                  </div>
                  <div class="form-group" v-if="testimony.actionDetail.actionLocation.camp">
                    <label class="col-sm-5 control-label">Camp</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span>{{testimony.actionDetail.actionLocation.camp}}</span>
                      </p>
                    </div>
                  </div>
                  <div class="form-group" v-if="testimony.actionDetail.actionLocation.ownPlace">
                    <label class="col-sm-5 control-label">Home</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span>{{testimony.actionDetail.actionLocation.ownPlace}}</span>
                      </p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Road</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="testimony.actionDetail.actionLocation.road">{{testimony.actionDetail.actionLocation.road}}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>
                </form>
              </div>

              <div class="col-md-5">
                <form v-if="testimony.actionDetail" class="form-horizontal">
                  <div class="form-group">
                    <label class="col-sm-5 control-label">How many aggressors?</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.actionDetail.aggressorNumber ? (testimony.actionDetail.aggressorNumber |
                        prettyNumber) : '-'}}</p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Aggressor Uniform</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.actionDetail.aggressorUniform ? testimony.actionDetail.aggressorUniform :'-'}}</p>
                    </div>
                  </div>
                   <div class="form-group">
                    <label class="col-sm-5 control-label">Aggressor distinctive sign</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.actionDetail.aggressorSign ? testimony.actionDetail.aggressorSign :'-'}}</p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Aggressor nationality/ethnic group/religion</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.actionDetail.aggressorAffiliations ? testimony.actionDetail.aggressorAffiliations :'-'}}</p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Aggressor names</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.actionDetail.aggressorNames ? testimony.actionDetail.aggressorNames : '-'}}</p>
                    </div>
                  </div>
                </form>

                <hr />

                <form v-if="testimony.victimCondition" class="form-horizontal">
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Already assisted?</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{typeof testimony.victimCondition.alreadyHelped === 'undefined' ? '-' :
                        testimony.victimCondition.alreadyHelped ? 'Yes' : 'No'
                      }}</p>
                    </div>
                  </div>

                  <div class="form-group" v-if="testimony.victimCondition.helpDescription">
                    <label class="col-sm-5 control-label">Help description</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.victimCondition.helpDescription}}</p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-5 control-label">Need assistance?</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{typeof testimony.victimCondition.helpNeeded === 'undefined' ? '-' :
                        testimony.victimCondition.helpNeeded ? 'Yes' : 'No'
                      }}</p>
                    </div>
                  </div>

                  <div class="form-group" v-if="testimony.victimCondition.helpNeededDescription">
                    <label class="col-sm-5 control-label">Assistance description</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.victimCondition.helpNeededDescription}}</p>
                    </div>
                  </div>
                </form>
              </div>

            </div>

            <hr v-if="testimony.threatDetail"/>

            <h4 v-if="testimony.threatDetail" class="subtitle">Threat Details</h4>

            <div v-if="testimony.threatDetail" class="row center-block details">

              <div class="col-md-offset-1 col-md-5">
                <form v-if="testimony.threatDetail" class="form-horizontal">
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Heard rumor ?</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.threatDetail.rumor ? 'Yes': testimony.threatDetail.rumor === false ? 'No':'-'}}</p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Bein afraid ?</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.threatDetail.fear ? 'Yes': testimony.threatDetail.fear === false ? 'No':'-'}}</p>
                    </div>
                  </div>
                </form>
              </div>

            </div>

            <hr v-if="testimony.threatDetail"/>

            <h4 v-if="testimony.actionPeriod && testimony.actionPeriod.startDate" class="subtitle">Period</h4>

            <div class="row center-block details">

              <div class="col-md-5">
                <form v-if="testimony.actionPeriod && testimony.actionPeriod.startDate" class="form-horizontal">
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Date</label>
                    <div class="col-sm-7">
                      <p v-if="testimony.actionPeriod.startDate !== testimony.actionPeriod.endDate" class="form-control-static">
                        From {{testimony.actionPeriod.startDate | prettyDate}} to {{testimony.actionPeriod.endDate | prettyDate}}
                      </p>
                      <p v-if="testimony.actionPeriod.startDate === testimony.actionPeriod.endDate" class="form-control-static">
                        {{testimony.actionPeriod.startDate | prettyDate}}
                      </p>
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-md-offset-1 col-md-5">
                <form v-if="testimony.actionPeriod" class="form-horizontal">
                  <div class="form-group" v-if="testimony.actionPeriod.startDate !== testimony.actionPeriod.endDate">
                    <label class="col-sm-5 control-label">Approximate ?</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">{{testimony.actionPeriod.exactDate ? 'No': 'Yes'}}</p>
                    </div>
                  </div>
                </form>
              </div>

            </div>

            <hr v-if="testimony.crimeDetail"/>

            <h4 v-if="testimony.crimeDetail" class="subtitle">Crime Details</h4>

            <div class="row center-block details">
              <div class="col-md-offset-1 col-md-5">
                <form v-if="testimony.crimeDetail" class="form-horizontal">
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Any victim?</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="typeof testimony.crimeDetail.anyVictim === 'undefined'">-</span>
                        <span v-else>{{testimony.crimeDetail.anyVictim ? 'Yes' : 'No'}}</span>
                      </p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-5 control-label">Where</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="testimony.crimeDetail.where ">{{testimony.crimeDetail.where}}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-5 control-label">When</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="testimony.crimeDetail.when ">{{testimony.crimeDetail.when}}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-5 control-label">How</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="testimony.crimeDetail.how ">{{testimony.crimeDetail.how}}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>
                </form>
              </div>

              <div class="col-md-5">
                <form v-if="testimony.crimeDetail" class="form-horizontal">
                  <div class="form-group">
                    <label class="col-sm-5 control-label">Number of victim</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="testimony.crimeDetail.victimNumber">{{testimony.crimeDetail.victimNumber}}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-5 control-label">Profiles of victim</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="testimony.crimeDetail.victimProfiles">{{testimony.crimeDetail.victimProfiles.join(', ')}}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-5 control-label">Is witness safe?</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="typeof testimony.crimeDetail.witnessState.isSafe === 'undefined'">-</span>
                        <span v-else>{{testimony.crimeDetail.witnessState.isSafe ? 'Yes' : 'No'}}</span>
                      </p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-5 control-label">Was threatened?</label>
                    <div class="col-sm-7">
                      <p class="form-control-static">
                        <span v-if="typeof testimony.crimeDetail.witnessState.hasBeenThreatened === 'undefined'">-</span>
                        <span v-else>{{testimony.crimeDetail.witnessState.hasBeenThreatened ? 'Yes' : 'No'}}</span>
                      </p>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <span v-if="testimony.actionDetail && testimony.actionDetail.details">
              <h4 class="subtitle">More details</h4>

              <div class="row center-block details">

                <div class="col-md-offset-1 col-md-5">
                  <div class="form-horizontal form-group">
                    <label class="col-sm-5 control-label">Details</label>
                  </div>
                </div>

                <div class="form-horizontal">
                  <div class="form-group">
                    <div class="col-sm-5">
                      <p class="form-control-static">{{testimony.actionDetail.details}}</p>
                    </div>
                  </div>
                </div>

              </div>
            </span>


            <!-- /.box-body -->
          </div>
        </div>

        <div class="box">
          <div class="box-header with-border">
            <h3 class="box-title">Additional data</h3>
            <i v-if="testimony && !editMode" class="fa fa-edit clickable pull-right" v-on:click="goToEditMode"></i>
          </div>
          <!-- /.box-header -->
          <div class="box-body">

            <p v-if="testimony && !editMode">{{testimony.comment}}</p>

            <textarea class="form-control" v-if="testimony && editMode" v-model="testimony.comment"></textarea>
            <!-- /.box-body -->
            <div class="box-footer add-data-testimony" v-if="testimony && editMode">
              <button v-on:click="goToReadMode" type="submit" class="btn btn-default">Cancel</button>
              <button v-on:click="save" type="submit" class="btn btn-info pull-right">Save</button>
            </div>
          </div>

          <div class="box-footer">
            <div v-if="testimony">
              <uploader :headers="getToken()" :multiple="false" :end-point="getUploadEndpoint()" @fileUploaded="refresh">
                <button slot="browse">Add attachments</button>
              </uploader>
              <ul v-if="testimony.attachments && testimony.attachments.length > 0" class="list-group">
                <li class="list-group-item list-group-item-action" v-for="file in testimony.attachments" :key="file">
                  <i class="fa fa-paperclip"></i>
                  <a class="file-name" v-bind:href="getUrl(file)">{{file}}</a>
                  <i data-toggle="tooltip" data-placement="bottom" title="Delete" class="fa fa-trash clickable pull-right"
                     v-on:click="confirmDeleteFile(file)"></i>

                  <file-previewer :id="id" :name="file" :source="getUrl(file)" />
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="box">
          <div class="box-header with-border">
            <h3 class="box-title">Recordings</h3>
          </div>
          <!-- /.box-header -->

          <div class="box-body">
            <ul v-if="testimony.recordings && testimony.recordings.length > 0" class="list-group">
              <li class="list-group-item list-group-item-action" v-for="recording in testimony.recordings" :key="recording">
                <i class="fa fa-paperclip"></i>
                <a class="file-name" v-bind:href="getRecordingUrl(recording)">{{recording}}</a>
                <audio controls controlsList="nodownload">
                  <source :src="getRecordingUrl(recording)" type="audio/webm" />
                </audio>
              </li>
            </ul>
          </div>
          <!-- /.box-body -->
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="box">
              <div class="box-header with-border">
                <h3 class="box-title">Location where testimony was saved</h3>
              </div>
              <div class="box-body">
                <osm-map v-if="testimony" :markers="[testimonyMarker]"></osm-map>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="box">
              <div class="box-header with-border">
                <h3 class="box-title">Body injuries</h3>
              </div>
              <div class="box-body">
                <injuries v-if="testimony" :victimCondition="testimony.victimCondition"></injuries>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="row">
          <signaletics v-if="testimony" :id="id" :status="testimony.status" type="testimonies"></signaletics>
        </div>

        <div class="row">
          <div class="box">
            <div class="box-header with-border">
              <h3 class="box-title">Related Cases</h3>
              <i data-toggle="tooltip" data-placement="bottom" title="Link" class="fa fa-link clickable pull-right" v-on:click="openLinkModal"></i>
            </div>
            <!-- /.box-header -->
            <div class="box-body" v-bind:class="{ 'no-padding': cases.length > 0 }">

              <p v-if="cases.length == 0">No related case</p>

              <div v-if="cases.length > 0" class="row">
                <div class="col-sm-12 table-responsive">

                  <table role="grid" class="table relative-case-table table-bordered table-striped no-margin">
                    <thead>
                    <tr role="row">
                      <th aria-label="CSS grade: activate to sort column ascending" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">
                        Name
                      </th>
                      <th aria-label="CSS grade: activate to sort column ascending" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">
                        Creation Date
                      </th>
                      <th aria-label="CSS grade: activate to sort column ascending" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">
                        Status
                      </th>
                      <th aria-label="CSS grade: activate to sort column ascending" colspan="1" rowspan="1" aria-controls="example1"
                          tabindex="0"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="even clickable" role="row" v-for="relatedCase in cases" v-on:click="goToCase(relatedCase)">
                      <td>{{relatedCase.name}}</td>
                      <td>{{relatedCase.creationDate | prettyDateTime}}</td>
                      <td>{{relatedCase.status}}</td>
                      <td><i data-toggle="tooltip" data-placement="bottom" title="Detach Case" class="fa fa-close clickable"
                             v-on:click.stop="confirmRemoveLink(relatedCase._id)"></i></td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- /.box-body -->
            </div>
          </div>
        </div>

        <div class="row">
          <anchors v-if="testimony && testimony.version" :id="id" type="testimonies" anchorDone="refresh" :version="testimony.version"/>
        </div>

        <div class="row">
          <div class="box">
            <div class="box-header with-border">
              <h3 class="box-title">Origin</h3>
            </div>
            <!-- /.box-header -->
            <div class="box-body">
              <p><label>Type : </label> {{ testimony.originInfo ? testimony.originInfo.origin : "UNKNOWN"}}</p>
              <p v-if="testimony.originInfo && testimony.originInfo.version"><label>Form version : </label> {{ testimony.originInfo.version }}</p>
              <p v-if="testimony.originInfo && testimony.originInfo.originId"><label>Platform ID : </label> {{ testimony.originInfo.originId }}</p>
              <p v-if="testimony.originInfo && testimony.originInfo.originalCode"><label>Original Code : </label> {{ testimony.originInfo.originalCode }} </p>
              <p><label>Web Code : </label> {{ testimony.randomId }}</p>
              <!-- /.box-body -->
            </div>
          </div>
        </div>

        <div class="row">
          <div class="box">
            <div class="box-header with-border">
              <h3 class="box-title">Similar Testimonies</h3>
            </div>
            <!-- /.box-header -->
            <div class="box-body" v-bind:class="{ 'no-padding': similars.length > 0 }">

              <p v-if="!similars || similars.length == 0">No similar testimony</p>

              <div v-if="similars && similars.length > 0" class="row">
                <div class="col-sm-12 table-responsive">

                  <table role="grid" class="table table-bordered table-striped no-margin">
                    <thead>
                    <tr role="row">
                      <th aria-label="CSS grade: activate to sort column ascending" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">
                        Location
                      </th>
                      <th aria-label="CSS grade: activate to sort column ascending" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">
                        Creation Date
                      </th>
                      <th aria-label="CSS grade: activate to sort column ascending" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">
                        Name
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="even" role="row" v-for="similar in similars">
                      <td>
                          <span v-if="similar && similar.actionDetail && similar.actionDetail.actionLocation">
                          {{similar.actionDetail.actionLocation.zone}}
                          </span>
                      </td>
                      <td class="sorting_1">{{similar.creationDate | prettyDateTime}}</td>
                      <td>
                          <span v-if="similar.victimIdentity">
                            {{similar.victimIdentity.firstName}} {{similar.victimIdentity.name}}
                          </span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- /.box-body -->
            </div>
          </div>
        </div>

        <div class="row" v-if="testimony && testimony.actionPeriod && testimony.actionPeriod.startDate && testimonyMarker">
          <automatic-data :testimonyLocation="testimonyMarker.coordinates" :testimonyTime="getStartTime()"/>
        </div>
      </div>
    </div>

    <confirm-modal message="Do you really want to archive this testimony ?" title="Archive Confirmation" @confirm="archive()"
                   id="ConfirmModal"></confirm-modal>
    <confirm-modal message="Do you really want to detach this testimony to that case ?" title="Detach Confirmation" @confirm="removeLink()"
                   id="ConfirmLinkModal"></confirm-modal>
    <confirm-modal message="Do you really want to delete this attachment ?" title="Delete Confirmation" @confirm="deleteFile()"
                   id="ConfirmDeleteFileModal"></confirm-modal>
    <link-case-modal ref="linkCaseModal" @link="linkAll" id="LinkCaseModal" :preselected="cases"></link-case-modal>
  </section>
</template>

<script>
  // import _ from 'lodash'
  import async from 'async'
  import moment from 'moment'
  import api from '../../api'
  import config from '../../config'
  import helper from '../../helper'
  import Multiselect from 'vue-multiselect'
  import FilePreviewer from './FilePreviewer.vue'

  const pluginURL = '/static/js/plugins/jvectormap/jquery-jvectormap-2.0.3.min.js'
  const mapURL = '/static/js/plugins/jvectormap/jquery-jvectormap-world-mill.js'

  export default {
    name: 'Testimony',
    components: {Multiselect, FilePreviewer},
    data () {
      return {
        id: this.$route.params.id,
        file: null,
        similars: [],
        testimony: null,
        testimonyMarker: null,
        editMode: false,
        cases: [],
        uploadEndPoint: null,
        anchors: [],
        caseToDetach: null,
        markers: []
      }
    },
    methods: {
      refresh (obj) {
        this.testimony = obj.response
      },
      getStartTime () {
        if (this.testimony && this.testimony.actionPeriod) {
          const hour = 12
          return moment(this.testimony.actionPeriod.startDate).hour(hour)
        }
      },
      getUrl (file) {
        return `${config.serverURI}/testimonies/${this.id}/attachments/${file}?token=${window.localStorage.getItem('token').substring(7)}`
      },
      getRecordingUrl (file) {
        return `${config.serverURI}/testimonies/${this.id}/recordings/${file}?token=${window.localStorage.getItem('token').substring(7)}`
      },
      getToken () {
        return {'Authorization': window.localStorage.getItem('token')}
      },
      getUploadEndpoint () {
        return `${config.serverURI}/testimonies/${this.id}/${this.testimony.version}/attachments`
      },
      confirm () {
        window.jQuery('#ConfirmModal').modal({})
      },
      confirmDeleteFile (file) {
        this.file = file
        window.jQuery('#ConfirmDeleteFileModal').modal({})
      },
      confirmRemoveLink (caseId) {
        this.caseToDetach = caseId
        window.jQuery('#ConfirmLinkModal').modal({})
      },
      removeLink () {
        const body = {
          testimonyId: this.id,
          version: this.testimony.version
        }
        return api.authenticatedRequest('delete', `/cases/${this.caseToDetach}/testimonies`, body)
          .then(response => {
            this.getTestimony()
            this.getRelatedCases()
          })
          .catch(error => {
            console.log(error)
          })
      },
      openLinkModal () {
        this.$refs.linkCaseModal.removeLinkedCases()
        window.jQuery('#LinkCaseModal').modal({})
      },
      linkAll (selectedCases) {
        async.eachOfSeries(selectedCases, this.link, (err) => {
          if (err) console.log(err)
          this.getTestimony()
          this.getRelatedCases()
        })
      },
      link (selectedCase, index, callback) {
        const body = {
          testimonyId: this.id,
          version: this.testimony.version + index
        }
        return api.authenticatedRequest('post', `/cases/${selectedCase._id}/testimonies`, body)
          .then(response => {
            callback()
          })
          .catch(error => {
            console.log(error)
            callback(error)
          })
      },
      getSimilars () {
        api.authenticatedRequest('get', `/testimonies/${this.id}/similar`)
          .then(response => {
            this.similars = response.data.data
          })
          .catch(error => {
            console.log(error)
            if (error.response.status === 401) { // InvalidCredentialsError
              this.response = 'Username/Password incorrect. Please try again.'
              return
            }
            this.response = 'Server appears to be offline'
          })
      },
      getRelatedCases () {
        api.authenticatedRequest('get', `/testimonies/${this.id}/cases`)
          .then(response => {
            this.cases = response.data.data
          })
          .catch(error => {
            console.log(error)
          })
      },
      goToCase (relatedCase) {
        const id = relatedCase._id ? relatedCase._id : relatedCase.id // TODO because of search result (ES expects an id field named 'id'). TO REFACTO
        this.$router.push({name: 'Case', params: {id: id}})
      },
      deleteFile () {
        api.authenticatedRequest('delete', `/testimonies/${this.id}/${this.testimony.version}/attachments/${this.file}`)
          .then(response => {
            this.testimony = response.data
          })
          .catch(error => {
            console.log(error)
            this.goToReadMode()
            if (error.response.status === 401) { // InvalidCredentialsError
              this.response = 'Username/Password incorrect. Please try again.'
              return
            }
            this.response = 'Server appears to be offline'
          })
      },
      archive () {
        api.authenticatedRequest('delete', `/testimonies/${this.id}?version=${this.testimony.version}`)
          .then(response => {
            this.$router.push({name: 'Testimonies'})
          })
          .catch(error => {
            console.log(error)
            this.goToReadMode()
            if (error.response.status === 401) { // InvalidCredentialsError
              this.response = 'Username/Password incorrect. Please try again.'
              return
            }
            this.response = 'Server appears to be offline'
          })
      },
      anchor () {
        api.authenticatedRequest('post', `/testimonies/${this.id}/anchor/${this.testimony.version}`)
          .then(response => {
            this.testimony = response.data.testimony
            this.getAnchors()
          })
          .catch(error => {
            console.log(error)
            this.goToReadMode()
            if (error.response.status === 401) { // InvalidCredentialsError
              this.response = 'Username/Password incorrect. Please try again.'
              return
            }
            this.response = 'Server appears to be offline'
          })
      },
      goToEditMode () {
        this.editMode = true
      },
      goToReadMode () {
        this.editMode = false
      },
      save () {
        api.authenticatedRequest('post', `/testimonies/${this.id}/comment`, {comment: this.testimony.comment, version: this.testimony.version})
          .then(response => {
            this.editMode = false
            this.testimony = response.data
          })
          .catch(error => {
            console.log(error)
            this.goToReadMode()
            if (error.response.status === 401) { // InvalidCredentialsError
              this.response = 'Username/Password incorrect. Please try again.'
              return
            }
            this.response = 'Server appears to be offline'
          })
      },
      getTestimony () {
        api.authenticatedRequest('get', `/testimonies/${this.id}`)
          .then(response => {
            this.testimony = response.data

            const testimonyMarker = helper.extractTestimonyMarker(this.testimony)
            if (testimonyMarker) {
              this.testimonyMarker = testimonyMarker
            }
          })
          .catch(error => {
            console.log(error)
            if (error.response.status === 401) { // InvalidCredentialsError
              this.response = 'Username/Password incorrect. Please try again.'
              return
            }
            this.response = 'Server appears to be offline'
          })
      },
      makeMap () {
        window.jQuery.getScript(pluginURL, () => {
          window.jQuery.getScript(mapURL, () => {
            window.jQuery('#world-map-markers').vectorMap({
              map: 'world_mill',
              regionStyle: {
                initial: {
                  fill: 'white',
                  'fill-opacity': 1,
                  stroke: 'rgb(80,80,80)',
                  'stroke-width': 0.5,
                  'stroke-opacity': 0.5
                },
                hover: {
                  'fill-opacity': 0.8,
                  cursor: 'pointer'
                },
                selected: {
                  fill: 'yellow'
                },
                selectedHover: {}
              },
              backgroundColor: '#747B83',
              zoomOnScroll: false,
              scaleColors: ['#C8EEFF', '#0071A4'],
              normalizeFunction: 'polynomial',
              markerStyle: {
                initial: {
                  fill: '#E14253',
                  stroke: '#b43442'
                },
                hover: {
                  stroke: '#747B83',
                  'stroke-width': 1,
                  cursor: 'pointer',
                  'fill-opacity': 0.8
                }
              },
              markerLabelStyle: {
                initial: {
                  'font-family': 'Verdana',
                  'font-size': '12',
                  'font-weight': 'bold',
                  cursor: 'default',
                  fill: 'black'
                },
                hover: {
                  cursor: 'pointer'
                }
              },
              markers: this.markers,
              onMarkerClick: this.onMarkerClick
            })
          })
        })
      },
      getMarkers () {
        /* Making API call to authenticate a user */
        api.authenticatedRequest('get', `/testimonies?size=100&sortField=creationDate&desc=true`)
          .then(response => {
            const data = response.data
            this.markers = data.data.filter((testimony) => {
              return testimony && testimony.actionDetail && testimony.actionDetail.actionLocation && testimony.actionDetail.actionLocation.geoLocation &&
                testimony.actionDetail.actionLocation.geoLocation.coordinates && testimony.actionDetail.actionLocation.geoLocation.coordinates.length === 2
            }).map((testimony) => {
              return {
                latLng: [testimony.actionDetail.actionLocation.geoLocation.coordinates[1], testimony.actionDetail.actionLocation.geoLocation.coordinates[0]],
                name: testimony.actionDetail.actionLocation.zone,
                id: testimony._id
              }
            })
            this.makeMap()
            this.total = data.total
          })
          .catch(error => {
            console.log(error)
            if (error.response.status === 401) { // InvalidCredentialsError
              this.response = 'Username/Password incorrect. Please try again.'
              return
            }
            this.response = 'Server appears to be offline'
          })
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.getTestimony()
        this.getRelatedCases()
        this.getSimilars()
      })
    }
  }
</script>
<style>
  .file-name {
    margin-left: 30px;
  }

  .clickable {
    cursor: pointer;
  }

  .vuejs-uploader label {
    margin-bottom: 20px;
  }

  .victimIdentity, .details {
    font-size: 15px;
  }

  .subtitle {
    padding-left: 20px;
  }

  .add-data-testimony {
    margin: 0 -10px;
    margin-top: 10px;
    padding-bottom: 0;
  }

  .add-data-testimony button:active:focus {
    outline: none;
  }

  .vuejs-uploader label {
    line-height: 40px;
    margin-bottom: 10px;
  }

  table.relative-case-table tbody tr:hover {
    background-color: #eee;
  }
</style>



// WEBPACK FOOTER //
// Testimony.vue?1055a408